import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@/core/data-fetching/queryKeys';
import { productsService } from '../api/products.service';
export function useApiProductsCatalogQuery(enabled = true) {
  return useQuery({ queryKey: [...queryKeys.products.catalogActive(), 'api'], enabled, staleTime: 30000,
    queryFn: async () => {
      const products = [];
      for (let page = 1; ; page++) {
        const result = await productsService.list({ featureKey: 'allow_api', active: true, page, limit: 200 });
        products.push(...result.data);
        if (page >= result.pagination.totalPages) return products;
      }
    },
  });
}
